var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppTable',{staticClass:"reconciliation-import-preview__table",attrs:{"primaryKey":"id","columns":_vm.previewDataColumns,"rows":_vm.previewDataRows,"textEmpty":'Загрузка данных'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }